import { MessageCircle, Facebook, Instagram, Mail, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT, LOGO_URL, waLink } from "@/lib/config";

const DEPOTS = ["Delhi NCR", "Mumbai", "Hyderabad", "Bengaluru", "Ahmedabad", "Kolkata"];

export default function Footer() {
  return (
    <>
      <footer data-testid="footer-container" className="relative bg-ink border-t border-white/10 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
              <div className="flex items-center gap-3 mb-5">
                <img src={LOGO_URL} alt="Infra Edge" data-testid="footer-brand-logo" className="h-12 w-12 rounded-full object-cover border border-white/10" />
                <div className="leading-none">
                  <span className="font-heading font-extrabold text-xl text-white uppercase tracking-wide">Infra Edge</span>
                  <span className="block font-mono text-[10px] tracking-[0.3em] text-brand uppercase">Cement Solutions</span>
                </div>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
                B2B cement supply across India. Every reputed brand, factory-direct dispatch, and contractor-grade site intelligence tools.
              </p>
              <div className="flex gap-3 mt-6">
                <a href={waLink("Hello Infra Edge!")} target="_blank" rel="noopener noreferrer" data-testid="footer-social-whatsapp" aria-label="WhatsApp" className="p-2.5 border border-white/10 text-gray-300 hover:text-brand hover:border-brand/50 transition-colors">
                  <MessageCircle className="h-4 w-4" />
                </a>
                <a href={CONTACT.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-social-facebook" aria-label="Facebook" className="p-2.5 border border-white/10 text-gray-300 hover:text-brand hover:border-brand/50 transition-colors">
                  <Facebook className="h-4 w-4" />
                </a>
                <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-social-instagram" aria-label="Instagram" className="p-2.5 border border-white/10 text-gray-300 hover:text-brand hover:border-brand/50 transition-colors">
                  <Instagram className="h-4 w-4" />
                </a>
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-social-email" aria-label="Email" className="p-2.5 border border-white/10 text-gray-300 hover:text-brand hover:border-brand/50 transition-colors">
                  <Mail className="h-4 w-4" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-brand mb-5">Pan-India Depot Network</h4>
              <ul className="grid grid-cols-2 gap-3">
                {DEPOTS.map((d) => (
                  <li key={d} className="flex items-center gap-2 text-sm text-gray-400">
                    <MapPin className="h-3.5 w-3.5 text-brand/70 shrink-0" />
                    {d}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-brand mb-5">Quick Links</h4>
              <ul className="space-y-3 text-sm">
                <li><a href="/#brands" className="text-gray-400 hover:text-brand transition-colors">Cement Brand Matrix</a></li>
                <li><Link to="/calculators" className="text-gray-400 hover:text-brand transition-colors">Contractor Estimators</Link></li>
                <li><Link to="/dashboard" className="text-gray-400 hover:text-brand transition-colors">Inventory Dashboard</Link></li>
                <li><a href="/#contact" className="text-gray-400 hover:text-brand transition-colors">Request Bulk Dispatch</a></li>
              </ul>
            </div>
          </div>

          <div className="mt-14 select-none pointer-events-none" aria-hidden="true">
            <p className="font-heading font-black uppercase leading-none text-stroke text-[18vw] md:text-[10rem] tracking-tight text-center">
              Infra Edge
            </p>
          </div>

          <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs font-mono text-gray-500">
            <span>© {new Date().getFullYear()} Infra Edge Cement Solutions. All rights reserved.</span>
            <span>IS 12269 · IS 8112 · IS 1489 · IS 455 compliant supply chain</span>
          </div>
        </div>
      </footer>

      <a
        href={waLink("Hello Infra Edge, I need assistance with a cement order.")}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-trigger"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full bg-brand text-ink flex items-center justify-center shadow-[0_0_30px_rgba(255,184,0,0.35)] hover:scale-105 transition-transform"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
    </>
  );
}
